export const TRANSFER_DEALBOOK_REQUEST = "TRANSFER_DEALBOOK_REQUEST";
export const TRANSFER_DEALBOOK_SUCCESS = "TRANSFER_DEALBOOK_SUCCESS";
export const TRANSFER_DEALBOOK_FAILURE = "TRANSFER_DEALBOOK_FAILURE";
export const TRANSFER_DEALBOOK_DATA_API_SUCCESS =
  "TRANSFER_DEALBOOK_DATA_API_SUCCESS";
